import {
  clampImageWidthPx,
  defaultImageWidthPxFromIntrinsic,
} from "./image-width";
import { isFacilityLogoMediaRef } from "./media";
import { EMAIL_BUILDER_BLANK_HEADER_IMAGE_BLOCK_ID } from "../emailBuilderTemplateConstants";
import type { ImageBlock, ImageIntrinsicSize } from "./types";

export const FACILITY_LOGO_HEADER_HEIGHT_PX = 56;

export function isHeaderFacilityLogoBlock(
  block: Pick<ImageBlock, "id" | "media" | "facilityLogoSizing">,
): boolean {
  if (!isFacilityLogoMediaRef(block.media)) {
    return false;
  }
  if (block.facilityLogoSizing === "header") {
    return true;
  }
  return block.id === EMAIL_BUILDER_BLANK_HEADER_IMAGE_BLOCK_ID;
}

export function facilityLogoHeaderWidthPx(
  intrinsicSize: ImageIntrinsicSize,
  contentMaxWidth: number,
): number {
  const { width, height } = intrinsicSize;
  if (height <= 0 || contentMaxWidth <= 0) {
    return clampImageWidthPx(FACILITY_LOGO_HEADER_HEIGHT_PX, contentMaxWidth);
  }
  const computed = Math.round(
    (FACILITY_LOGO_HEADER_HEIGHT_PX * width) / height,
  );
  return clampImageWidthPx(computed, contentMaxWidth);
}

export function defaultWidthPxForImageBlock(
  block: Pick<ImageBlock, "id" | "media" | "facilityLogoSizing">,
  intrinsicSize: ImageIntrinsicSize,
  contentMaxWidth: number,
): number | null {
  if (isHeaderFacilityLogoBlock(block)) {
    return facilityLogoHeaderWidthPx(intrinsicSize, contentMaxWidth);
  }
  return defaultImageWidthPxFromIntrinsic(intrinsicSize, contentMaxWidth);
}
